// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/generation_sales_plan_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { GenerationSalesPlanService } from "./generation_sales_plan_service_pb";

/**
 * ListGenerationSalesPlans returns the generation-sales plan list-screen
 * rows for the authenticated organization. When include_all_versions is
 * false (= default / zero value), only the latest version of each
 * submission is returned.
 *
 * @generated from rpc bffuser.v1.GenerationSalesPlanService.ListGenerationSalesPlans
 */
export const listGenerationSalesPlans = GenerationSalesPlanService.method.listGenerationSalesPlans;

/**
 * DownloadGenerationSalesPlanXml returns the plan XML content and its
 * OCCTO BP-規格ファイル名 for the specified plan submission. The BFF
 * handler resolves organization_id from the eauth session.
 *
 * @generated from rpc bffuser.v1.GenerationSalesPlanService.DownloadGenerationSalesPlanXml
 */
export const downloadGenerationSalesPlanXml = GenerationSalesPlanService.method.downloadGenerationSalesPlanXml;

/**
 * GetGenerationSalesPlanDetail returns the full detail of a single
 * generation-sales plan submission, including per-BG generation values,
 * sales / procurement breakdown rows, and the previous submitted version
 * for diff display. All data is returned in a single RPC to minimise
 * round-trips. The BFF handler resolves organization_id from the eauth
 * session.
 *
 * @generated from rpc bffuser.v1.GenerationSalesPlanService.GetGenerationSalesPlanDetail
 */
export const getGenerationSalesPlanDetail = GenerationSalesPlanService.method.getGenerationSalesPlanDetail;

/**
 * SubmitGenerationSalesPlan submits a generated generation-sales plan
 * submission to the OCCTO portal. On success the status transitions to
 * SUBMITTED and submitted_at is populated. The BFF handler resolves
 * organization_id from the eauth session.
 *
 * @generated from rpc bffuser.v1.GenerationSalesPlanService.SubmitGenerationSalesPlan
 */
export const submitGenerationSalesPlan = GenerationSalesPlanService.method.submitGenerationSalesPlan;

/**
 * CreateGenerationSalesPlan triggers the creation of a new generation-sales
 * plan submission. The backend enqueues a plan generation outbox entry and
 * returns the new submission id with status GENERATING. The worker assembles
 * the plan values asynchronously. kind is fixed to GENERATION_SALE by the
 * BFF handler.
 *
 * @generated from rpc bffuser.v1.GenerationSalesPlanService.CreateGenerationSalesPlan
 */
export const createGenerationSalesPlan = GenerationSalesPlanService.method.createGenerationSalesPlan;
